<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        实例数据
        <a href="#" class="hidden" ref="download"></a>
      </div>
      <b-form>
        <b-form-group label="服务名" label-for="service_code">
          <b-form-select
              id="service_code"  v-model="data.service_code"
              :options="services" :disabled="true">
          </b-form-select>
        </b-form-group>
        <b-form-group label="产品名" label-for="product_code">
          <b-form-select
              id="product_code"  v-model="data.product_code"
              :options="products" :disabled="true">
          </b-form-select>
        </b-form-group>
        <b-tabs>
          <b-tab v-for="(inter_conf, inter_name) in data.interfaces.download" :key="inter_name"
                 :title="inter_conf.name || inter_name">
            <b-row><b-col><h4>{{ inter_conf.desc }}</h4></b-col></b-row>
            <conf-node :items="inter_conf.param" :useDefault="true" :forUser="true" :strict="false"></conf-node>
            <b-row class="mt-2">
              <b-col>
                <b-button v-if="inter_conf.return_type === 'FILE'" @click="requestInterface('download', inter_name)" variant="outline-success">
                  <i class="fa fa-check"></i> 下载
                </b-button>
                <b-button v-else @click="requestInterface('download', inter_name)" variant="outline-primary">
                  <i class="fa fa-check"></i> 执行
                </b-button>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-form>
      <div slot="footer">
        <b-button @click="$router.go(-1)" size="sm" variant="outline-secondary"><i class="fa fa-remove"></i> 返回</b-button>
      </div>
    </b-card>

    <b-card title="数据图表" v-if="result.chartOption.dataset.source.length">
      <echart :options="result.chartOption" style="width:100%"></echart>
    </b-card>
    <b-card title="数据查询结果" v-if="result.items">
      <b-table responsive="sm" :items="result.items" :fields="result.fields" :current-page="result.currentPage">
        <template #cell(__show_detail__)="row">
          <b-button size="sm" @click.stop="row.toggleDetails" class="mr-2">详细信息</b-button>
        </template>
        <template #cell(row-details)="row">
          <b-card>
            <b-row class="mb-2" v-for="(conf, index) in result.hidden_fields" :key="index">
              <b-col sm="3" class="text-sm-right"><b>{{ conf.label }}</b></b-col>
              <b-col v-if="conf.show_type === 'PIC'">
                <img :src="row.item[conf.key]" height="150px"/>
              </b-col>
              <b-col v-else>{{ row.item[conf.key] }}</b-col>
            </b-row>
          </b-card>
        </template>
      </b-table>
      <nav>
        <b-pagination :total-rows="result.totalRows" :per-page="result.perPage" v-model="result.currentPage"
          @change="changePage" first-text="<<" last-text=">>" prev-text="<" next-text=">"/>
      </nav>
    </b-card>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import utils from '@/utils/utils'
import ConfNode from '@/components/Confnode'

export default {
  name: 'app-data',
  mixins: [Error],
  components: {
    ConfNode
  },
  data: () => {
    return {
      data: {
        service_code: '',
        product_code: '',
        code: '',
        interfaces: '',
        descs: '',
        confs: ''
      },
      products: {},
      services: {},
      result: {
        interData: null,
        url: '',
        query: {},
        items: null,
        fields: [],
        hidden_fields: [],
        perPage: 10,
        currentPage: 1,
        totalRows: 0,
        chartOption: {
          tooltip: {},
          legend: {},
          xAxis: {type: 'category'},
          yAxis: {},
          series: [],
          dataset: {
            dimensions: [],
            source: []
          }
        }
      }
    }
  },
  created () {
    this.$ajax.all([
      this.$ajax.get(api.getProductList()),
      this.$ajax.get(api.getServiceList())
    ]).then(([productdata, serviceData]) => {
      this.products = {
        null: {text: '请选择', disabled: true}
      }
      productdata.products.forEach((product) => {
        this.products[product.code] = product.name
      })
      this.services = {}
      serviceData.services.forEach((service) => {
        this.services[service.code] = service.name
      })
    })
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.$ajax.all([this.$ajax.get(api.getAppDetail(
        this.$route.params.serviceCode, this.$route.params.appCode,
        this.$route.query.productCode
      ))]).then(([appData]) => {
        this.data = appData.app_info
      }, (res) => {
        this.handleError(res)
      })
    },
    requestInterface (interCate, interName) {
      this.result.interData = this.data.interfaces[interCate][interName]
      Object.keys(this.result.interData.param).map((field) => {
        if (['__tree__'].indexOf(field) === -1) {
          let conf = this.result.interData.param[field].__Value__
          this.result.query[field] = conf.__value__ || conf.__default__
        }
      })

      this.result.url = this.result.interData.address
      this.result.perPage = parseInt(this.result.query.limit || this.result.perPage)
      this.clearData()
      if (this.result.interData.return_type === 'CHART') {
        this.fetchChart()
      } else if (this.result.interData.return_type === 'FILE') {
        this.downloadResult()
      } else {
        this.fetchResult()
      }
    },
    downloadResult () {
      let url = this.result.url + '?' + utils.parseQs(this.result.query)
      this.$ajax.post(api.getServiceSign(this.$route.params.serviceCode), {
        url: url, params: ''
      }).then((res) => {
        return this.$ajax.get(url, {responseType: 'arraybuffer', headers: res.data})
      }).catch((res) => {
        if (res.response && res.response.status !== 200) {
          this.$message.error('导出失败')
        } else {
          let fileUrl = window.URL.createObjectURL(new Blob(
            [res.data], {type: res.headers['content-type']}
          ))
          this.$refs.download.href = fileUrl
          this.$refs.download.download = 'data.zip'
          this.$refs.download.click()
        }
      })
    },
    fetchResult () {
      this.result.interData.structure.map((item) => {
        if (!item.hidden) {
          this.result.fields.push(item)
        } else {
          this.result.hidden_fields.push(item)
        }
      })
      if (this.result.hidden_fields.length) {
        this.result.fields.push({key: '__show_detail__', label: ''})
      }
      let url = this.result.url + '?' + utils.parseQs(this.result.query)
      this.$ajax.post(api.getServiceSign(this.$route.params.serviceCode), {
        url: url, params: ''
      }).then((res) => {
        return this.$ajax.get(url, {headers: res.data})
      }).catch((res) => {
        if (res.data.success) {
          this.result.items = res.data.data
          this.result.totalRows = res.data.total_num
        } else {
          if (res.data.msg) {
            this.$message.error(res.data.msg)
          } else {
            this.$message.error('查询失败')
          }
        }
      })
    },
    fetchChart () {
      let url = this.result.url + '?' + utils.parseQs(this.result.query)
      this.$ajax.post(api.getServiceSign(this.$route.params.serviceCode), {
        url: url, params: ''
      }).then((res) => {
        return this.$ajax.get(url, {headers: res.data})
      }).catch((res) => {
        if (res.data.success) {
          let chartConf = this.result.interData.chart_conf[res.data.chart_type]
          if (!chartConf) {
            this.$message.error('查询失败')
          }
          this.result.chartOption.dataset.dimensions.push(chartConf.x_axis)
          chartConf.y_axis.map((y) => {
            this.result.chartOption.dataset.dimensions.push(y.field)
            this.result.chartOption.series.push({
              type: chartConf.type, name: y.name
            })
          })
          this.result.chartOption.dataset.source = res.data.data
        } else {
          this.$message.error('查询失败')
        }
      })
    },
    clearData () {
      this.result.fields = []
      this.result.hidden_fields = []
      this.result.items = null
      this.result.totalRows = 0
      // reset chart
      this.result.chartOption.dataset = {
        dimensions: [], source: []
      }
      this.result.chartOption.series = []
    },
    changePage (page) {
      this.clearData()
      this.result.currentPage = page
      this.result.query.start = this.result.perPage * (page - 1)
      this.fetchResult()
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProjectData.vue?5e76f812